import { render, staticRenderFns } from "./mc-tally.tests.vue?vue&type=template&id=4c7d6bde&scoped=true"
import script from "./mc-tally.tests.vue?vue&type=script&lang=ts"
export * from "./mc-tally.tests.vue?vue&type=script&lang=ts"
import style0 from "./mc-tally.tests.vue?vue&type=style&index=0&id=4c7d6bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7d6bde",
  null
  
)

export default component.exports